import type { FC, ReactElement } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { CoreDispatch, useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const ExitConfirmationConnected: FC = (): ReactElement => {
  const dispatch: CoreDispatch = useCoreDispatch();
  const redirectToLobby = useRedirectToLobbyCallbackConnected();

  const action = [
    <Button
      key="CANCEL"
      tk="CANCEL"
      variant={ButtonVariant.MAIN}
      onClick={() => {
        cancel(dispatch);
      }}
    />,
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        redirectToLobby();
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk="EXIT_TO_LOBBY_CHECK" />
    </BlockingModalContent>
  );
};

export const cancel = (dispatch: CoreDispatch): void => {
  dispatch(popupActions.dismissPopup(PopupType.ExitConfirmation));
};
